import React, { useState, useEffect, useRef } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  C2_FONT,
  c2DialogPaperSx,
  c2DialogTitleSx,
  c2IconBoxSx,
  c2PrimaryBtnSx,
  c2SecondaryBtnSx,
} from './conecta2ModalStyles';

export default function ConfirmationDialogRaw(props) {
  const { onClose, value: valueProp, open, ...other } = props;
  const { t, i18n  } = useTranslation();
  const isRTL = i18n.dir();
  const [value, setValue] = useState(valueProp);
  const radioGroupRef = useRef(null);
  const options = useSelector(state => state.cancelreasondata.simple);

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose(value);
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <Dialog
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose()
        }
      }}
      style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}
      PaperProps={{ sx: c2DialogPaperSx }}
    >
      <DialogTitle id="confirmation-dialog-title" sx={c2DialogTitleSx}>
        <Box sx={c2IconBoxSx}>
          <InfoOutlinedIcon sx={{ color: '#6411ED', fontSize: 22 }} />
        </Box>
        {t('select_reason', { defaultValue: 'Selecciona un motivo' })}
      </DialogTitle>
      <DialogContent dividers sx={{ fontFamily: C2_FONT, borderColor: '#EDE8F7', px: 2.5 }}>
        <RadioGroup
          ref={radioGroupRef}
          aria-label="ringtone"
          name="ringtone"
          value={value}
          onChange={handleChange}
        >
          {(options || []).map((option) => (
            <FormControlLabel
              value={option}
              key={option}
              control={<Radio sx={{ color: '#6411ED', '&.Mui-checked': { color: '#6411ED' }, m: 1 }} />}
              label={option}
              sx={{
                py: 0.5,
                px: 1,
                '& .MuiFormControlLabel-label': {
                  fontFamily: C2_FONT,
                  color: '#221448',
                  fontSize: '0.92rem',
                },
              }}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 2.5, pt: 1, gap: 1 }}>
        <Button autoFocus onClick={handleCancel} variant="outlined" sx={c2SecondaryBtnSx}>
          {t('cancel', { defaultValue: 'Cancelar' })}
        </Button>
        <Button onClick={handleOk} variant="contained" sx={c2PrimaryBtnSx}>
          {t('ok', { defaultValue: 'Aceptar' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialogRaw.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
